import { useEffect, useRef } from 'react';

export const useComponentMount = (onComponentMount: () => void) =>
  useEffect(onComponentMount, []);

export const useEventListener = (
  eventName: string,
  handler: Function,
  element: any = document
) => {
  const savedHandler = useRef<Function>();

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const isSupported = element && element.addEventListener;
    if (!isSupported) return;

    const eventListener = (event: any) => {
      if (typeof savedHandler.current === 'function') {
        return savedHandler.current(event);
      }
      return null;
    };
    element.addEventListener(eventName, eventListener);

    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
};
